import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ee275d28"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "booking-extra__quantity" }
const _hoisted_2 = { class: "input-container" }
const _hoisted_3 = { class: "header" }
const _hoisted_4 = {
  key: 0,
  class: "message"
}

import BaseQuantity from "@/components/base/BaseQuantity.vue";
import { DirectionEnum } from "@/models/enums";
import { Extra } from "@/models/www/Extra";
import { ResourceState } from "@/models/www/store/BookingState";
import { useBookingStore } from "@/store/booking";
import { computed } from "vue";

interface Props {
  extra: Extra
  index: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BookingExtraQuantity',
  props: {
    extra: null,
    index: null
  },
  setup(__props: any) {

const props = __props as {
  extra: Extra
  index: number;
}



const bookingStore = useBookingStore();

const inputValue = computed({
  get(): number {
    const resources = bookingStore.getResources(DirectionEnum.Outward);
    return resources.filter((x) => x.identifier === props.extra.identifier)
      .length;
  },
  set(value: number) {
    bookingStore.setResource(DirectionEnum.Outward, value, {
      identifier: props.extra.identifier,
      code: props.extra.resourceCode,
      route: props.extra.route ?? "",
    } as ResourceState);
  },
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h4", null, _toDisplayString(__props.extra.description), 1),
        _createElementVNode("p", null, _toDisplayString(`Max ${__props.extra.maxBookable}`), 1)
      ]),
      _createVNode(BaseQuantity, {
        id: __props.extra.identifier,
        name: `${__props.extra.identifier}-${__props.index}`,
        minValue: 0,
        maxValue: __props.extra.maxBookable,
        disabled: __props.extra.disabled,
        modelValue: _unref(inputValue),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(inputValue) ? (inputValue).value = $event : null))
      }, null, 8, ["id", "name", "maxValue", "disabled", "modelValue"])
    ]),
    (__props.extra.notBookableMessage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(__props.extra.notBookableMessage), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})